module.exports = __webpack_public_path__ + "img/csr_swiper_01_06.7e95bf71.jpg";